module.exports = __webpack_public_path__ + "media/images/vr/promo-tecnologia-section-bg-7e1d40f37b5e851c8452073784b3ab23.jpg";